import { render } from "./DigitalTransformationArticles.vue?vue&type=template&id=7bb15988&scoped=true"
import script from "./DigitalTransformationArticles.vue?vue&type=script&lang=js"
export * from "./DigitalTransformationArticles.vue?vue&type=script&lang=js"

import "./DigitalTransformationArticles.vue?vue&type=style&index=0&id=7bb15988&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb15988"]])

export default __exports__